import React from 'react'
import { useRouter } from 'next/router'
import { Container } from '@chakra-ui/react'

import MainContent from '@/components/MainContent'
import AppOverview from '@/modules/Dashboard'
import { useStores } from '@/stores/index'
import { TablePageLoader } from '@/components/SkeletonLoaders'
import Meta from '@/components/Meta'
import { bootstrapWebViewAuthSession } from '@/lib/webviewAuthBootstrap'

const Dashboard = () => {
  const { auth } = useStores()
  const router = useRouter()
  const [checkingSession, setCheckingSession] = React.useState(false)

  React.useEffect(() => {
    let cancelled = false

    const ensureSession = async () => {
      if (auth.currentOrganization?.id) return

      const bootstrap =
        typeof window !== 'undefined' &&
        (new URLSearchParams(window.location.search).get('bootstrap') === '1' ||
          new URLSearchParams(window.location.search).get('bootstrap') === 'true')

      if (bootstrap) {
        setCheckingSession(true)
        try {
          await bootstrapWebViewAuthSession()
        } finally {
          if (!cancelled) setCheckingSession(false)
        }
      }

      if (cancelled) return

      if (!auth.currentOrganization?.id) {
        // admin not onboarded yet (no organization on account)
        router.push('/onboarding')
      }
    }

    void ensureSession()
    return () => {
      cancelled = true
    }
  }, [auth.currentOrganization])

  if (!auth.currentOrganization || checkingSession) {
    return (
      <Container pt="20">
        <TablePageLoader />
      </Container>
    )
  }

  return (
    <>
      <Meta title="Dashboard" />
      <MainContent>
        <AppOverview />
      </MainContent>
    </>
  )
}

export default Dashboard
